export const videoId = 'SG3ZJsJANFE';
export const videoUlr =
  'https://www.youtube.com/embed/${videoId}?autoplay=1&loop=1&enablejsapi=1&playerapiid=featuredytplayer&controls=0&modestbranding=1&rel=0&showinfo=0&color=white&iv_load_policy=3&theme=light&wmode=transparent&mute=1';
export const localUlr = '/videos/video.mp4';
